import { Component } from '@angular/core';

@Component({
  selector: 'app-mad-buttons-demo-color-spec',
  imports: [],
  templateUrl: './mad-buttons-demo-color-spec.component.html',
  styleUrl: './mad-buttons-demo-color-spec.component.scss',
})
export class MadButtonsDemoColorSpecComponent {}
